const ACTION_TYPES = {
    UPDATE_BASKET: 'UPDATE_BASKET',
    UPDATE_PICKUP_STORE_DETAILS: 'UPDATE_PICKUP_STORE_DETAILS',
    SHOW_BASKET_ERROR: 'SHOW_BASKET_ERROR',
    SHOW_BASKET_WARNING: 'SHOW_BASKET_WARNING',
    SHOW_STICKY_APPLE_PAY_BTN: 'SHOW_STICKY_APPLE_PAY_BTN',
    SHOW_PAYPAL_RESTRICTED_MESSAGE: 'SHOW_PAYPAL_RESTRICTED_MESSAGE',
    ADD_PENDING_SKU: 'ADD_PENDING_SKU',
    CLEAR_PENDING_SKU: 'CLEAR_PENDING_SKU',
    REMOVE_PENDING_SKU: 'REMOVE_PENDING_SKU',
    GET_BASKET_TYPE: 'GET_BASKET_TYPE',
    SET_BASKET_TYPE: 'SET_BASKET_TYPE'
};

const initialState = {
    isInitialized: false,
    itemCount: 0,
    items: [],
    rewards: [],
    promos: [],
    appliedPromotions: [],
    samples: [],
    products: [],
    subtotal: '$0.00',
    rawSubTotal: '$0.00',
    pendingBasketSkus: [],
    currentBasketType: null
};

/**
 * If removing property from basket state, don't remove property entirely.
 * If you do, state will not reflect change due to object.assign.
 * Instead set property value to null to simulate removal, this will update state.
 */
const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE_BASKET:
            return Object.assign({}, state, {
                basketLevelMessages: undefined,
                promoWarning: undefined,
                firstBuyOrderDiscount: undefined
            }, action.basket);
        case ACTION_TYPES.UPDATE_PICKUP_STORE_DETAILS: {
            return Object.assign({}, state, { 
                pickupBasket: Object.assign({}, state.pickupBasket, { storeDetails: action.storeDetails })
            });
        }
        case ACTION_TYPES.SHOW_BASKET_ERROR: {
            let basket = (action.error && action.itemsAndErrors) ?
                Object.assign({}, state, { items: action.itemsAndErrors }) :
                state.items;
            return Object.assign({}, state, {
                basket,
                error: action.error
            });
        }
        case ACTION_TYPES.SHOW_BASKET_WARNING: {
            return Object.assign({}, state, { basketItemWarnings: action.basketItemWarnings });
        }
        case ACTION_TYPES.SHOW_STICKY_APPLE_PAY_BTN:
            return Object.assign({},
                state,
                { showStickyApplePayBtn: action.showStickyApplePayBtn }
            );
        case ACTION_TYPES.SHOW_PAYPAL_RESTRICTED_MESSAGE: {
            const nextState = action.isPickup ? 
                Object.assign({}, state, { 
                    pickupBasket: Object.assign({}, state.pickupBasket, { showPaypalRestrictedMessage: action.showPaypalRestrictedMessage })
                }) :
                Object.assign({}, state, { showPaypalRestrictedMessage: action.showPaypalRestrictedMessage });

            return nextState;
        }
        case ACTION_TYPES.CLEAR_PENDING_SKU:
        case ACTION_TYPES.ADD_PENDING_SKU:
        case ACTION_TYPES.REMOVE_PENDING_SKU:
            return Object.assign(
                {},
                state,
                { pendingBasketSkus: action.pendingBasketSkus }
            );
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
